import { render, staticRenderFns } from "./_step.vue?vue&type=template&id=c986bba0&"
import script from "./_step.vue?vue&type=script&lang=js&"
export * from "./_step.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/pages/_p-persona-step.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports